exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "scaling-policy-summary .alarm-name {\n  word-break: break-all;\n}\nscaling-policy-summary .actions {\n  font-size: 85%;\n  margin: 0 0 15px 0;\n  border-bottom: 1px solid var(--color-alto);\n}\nscaling-policy-summary .actions .btn-left {\n  padding-left: 0;\n  border-left-width: 0;\n}\n", ""]);

